import React from 'react';
import { StyleSheet, View } from 'react-native';
import { isFuture } from 'date-fns';
import { useRecoilValue } from 'recoil';

import { lowerDisplayLineTestIDs, Theme } from '@constants';
import { useWeatherAlertsCrawl } from '@hooks';
import { ldlPlaylistState } from '@store';

import { LDLDebugShortcuts } from './LDLDebugShortcuts';

import { DEBUG } from '../../../helpers/Platform';
import { TimeUtils } from '../../../helpers/TimeUtils';
import { TWCTimeLogoAnimated } from '../../myWeather/TWCTimeLogo/TWCTimeLogoAnimated/TWCTimeLogoAnimated';
import { LDLAlertCrawl } from '../LDLAlertCrawl/LDLAlertCrawl';
import { LDLProductPlayer } from '../LDLProductPlayer/LDLProductPlayer';
import { LDL } from '../styles';

const LDLBaseAPI = () => {
  const severeAlerts = useWeatherAlertsCrawl(true);
  const { isSevereCrawlEnabled } = useRecoilValue(ldlPlaylistState);

  return (
    <View importantForAccessibility={'no-hide-descendants'}>
      {DEBUG && <LDLDebugShortcuts />}
      <LDLBaseUI isSevereCrawlEnabled={isSevereCrawlEnabled} severeAlerts={severeAlerts}>
        <LDLProductPlayer.API />
      </LDLBaseUI>
    </View>
  );
};

const LDLBaseUI = ({ severeAlerts, isSevereCrawlEnabled, children }) => {
  const { alerts, highestExpireTimeUTC } = severeAlerts;
  const hasSevereAlerts = alerts.length > 0;
  const shouldCrawl =
    isSevereCrawlEnabled && hasSevereAlerts && isFuture(TimeUtils.dateFromEpoch(highestExpireTimeUTC));

  return (
    <>
      <View style={styles.ldlWrapper}>
        <TWCTimeLogoAnimated testID={lowerDisplayLineTestIDs.logoAndTimeWidget} />
        <LDLAlertCrawl.UI data={severeAlerts} shouldCrawl={shouldCrawl}>
          {children}
        </LDLAlertCrawl.UI>
      </View>
      <View style={styles.ldlCover} />
    </>
  );
};

export const LDLBase = {
  API: LDLBaseAPI,
  UI: LDLBaseUI,
};

const styles = StyleSheet.create({
  ldlCover: {
    backgroundColor: Theme.blackPearlBlack,
    flex: 1,
  },
  ldlWrapper: {
    flexDirection: 'row',
    height: Theme.px(60),
    paddingLeft: LDL.paddingLeft,
  },
});
